export const menuDotsIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill="currentColor"><circle cx="22" cy="16" r="2"/><circle cx="16" cy="16" r="2"/><circle cx="10" cy="16" r="2"/></g></svg>`,
    name: 'menu-dots' as const
};